import { useTranslation } from "@onefront/react-sdk";
import { Box, Divider, Stack, useTheme } from "@vapor/react-material";
import { WsTag } from "@onefront/react-workspace-components";
import React from "react";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndustryWindows } from "@fortawesome/pro-regular-svg-icons";
import SidebarMenu from "../../../../components/general/sidebar-menu";
import { BusinessSteps } from "../../../../@types/enums/business/BusinessSteps";

const mockedSections = t => [
    {
        key: BusinessSteps.details,
        label: t(`step.business.${BusinessSteps.details}`)
    },
    {
        key: BusinessSteps.accounting,
        label: t(`step.business.${BusinessSteps.accounting}`)
    },
    {
        key: BusinessSteps.sectionals,
        label: t(`step.business.${BusinessSteps.sectionals}`)
    },
    {
        key: BusinessSteps.vatconfiguration,
        label: t(`step.business.${BusinessSteps.vatconfiguration}`)
    },
    {
        key: BusinessSteps.ivaprorata,
        label: t(`step.business.${BusinessSteps.ivaprorata}`)
    }
];
interface DetailsBusinessProps {
    data: any;
    section?: string;
    isEditing?: boolean;
    onChange?: (section: any) => void;
    withoutMenu?: boolean;
}

export const DetailsBusiness = ({ data, section, onChange, withoutMenu }: DetailsBusinessProps) => {
    const { t } = useTranslation();
    const {
        palette: {
            primary: { textDefaultColor: YankeesBlue }
        }
    } = useTheme();

    return (
        <Stack direction={"column"} spacing={2.5}>
            <Box px={4} pt={4}>
                <WsTag label={<>{t(`details.sections.business`)}</>} textColor="DarkImperialBlue" type="bodySmall500" />
            </Box>
            <Box px={4}>
                <ExtendedTypography variant="titleMedium" color="primary.textTitleColor" gutterBottom>
                    <Box
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                        style={{
                            display: "-webkit-box",
                            WebkitLineClamp: "3",
                            WebkitBoxOrient: "vertical"
                        }}
                    >
                        <FontAwesomeIcon icon={faIndustryWindows} style={{ marginRight: 10 }} />
                        {data?.description}
                    </Box>
                </ExtendedTypography>
            </Box>
            <Box px={4} pb={2}>
                <Stack spacing={1} direction="column">
                    <ExtendedTypography component={"div"} variant="body" color={YankeesBlue}>
                        {" "}
                        {t("details.business.cards.ateco.title")}: {data?.atecoCode}
                    </ExtendedTypography>
                    <ExtendedTypography component={"div"} variant="body" color={YankeesBlue}>
                        {t("details.registry.fields.denomination")}: {data?.atecoCodeDescription}
                    </ExtendedTypography>
                </Stack>
            </Box>
            {!withoutMenu && (
                <>
                    <Divider light />
                    <Box px={4} pt={2}>
                        <ExtendedTypography component={"div"} variant="titleSmall" color="primary.textTitleColor">
                            {t("details.sidebarMenuTitle")}
                        </ExtendedTypography>
                    </Box>

                    <Box px={4}>
                        <SidebarMenu sections={mockedSections(t)} activeSection={section} onChange={onChange} />
                    </Box>
                </>
            )}
        </Stack>
    );
};
